import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import { compact, find, isEmpty, map, orderBy } from 'lodash';
import { PRIMARY_DISPLAY } from '../constants';
function communicationTypeDisplayName(contactCommunicationTypesEnums, value) {
  var displayName = (find(contactCommunicationTypesEnums, {
    value: value
  }) || {}).display_name;
  return displayName && displayName.toLowerCase();
}
function getAdditionalInfoDisplay(_ref) {
  var _context;
  var _ref$communicationTyp = _ref.communicationTypes,
    communicationTypes = _ref$communicationTyp === void 0 ? [] : _ref$communicationTyp,
    _ref$enums = _ref.enums,
    enums = _ref$enums === void 0 ? [] : _ref$enums,
    _ref$isPrimary = _ref.isPrimary,
    isPrimary = _ref$isPrimary === void 0 ? false : _ref$isPrimary;
  if (!isPrimary && isEmpty(communicationTypes)) {
    return '';
  }
  var items = compact(_concatInstanceProperty(_context = [isPrimary && PRIMARY_DISPLAY]).call(_context, _toConsumableArray(orderBy(map(communicationTypes, function (type) {
    return communicationTypeDisplayName(enums, type);
  })))));
  return "(".concat(items.join(', '), ")");
}
export default getAdditionalInfoDisplay;
//# sourceMappingURL=getAdditionalInfoDisplay.js.map